import React from "react";
import PropTypes from "prop-types";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		width: "200px",
		display: "flex",
		WebkitFlexDirection: "column",
		MsFlexDirection: "column",
		flexDirection: "column",
		position: "relative",
		"& .icon24": {
			position: "absolute",
			left: "-46px",
			top: "-30px",
		},
	},
	header: {
		fontFamily: theme.fonts.bold,
		fontSize: "24px",
		lineHeight: "1",
		color: theme.palette.colors.white,
		marginBottom: "21px",
		minHeight: "48px",
	},
	text: {
		fontFamily: theme.fonts.light,
		fontSize: "14px",
		lineHeight: "1.29",
		color: theme.palette.colors.white,
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			width: "100%",
			padding: "0 8.33%",
			"& .icon24": {
				position: "absolute",
				left: "50%",
				transform: "translateX(-50%)",
				top: "-40px",
			},
		},
		header: {
			fontSize: "18px",
			marginBottom: "12px",
			textAlign: "center",
			minHeight: "0",
		},
		text: {
			textAlign: "center",
			fontSize: "12px",
			lineHeight: "1.5",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			width: "230px",
			padding: "0 30px",
			"& .icon24": {
				position: "absolute",
				left: "50%",
				transform: "translateX(-50%)",
				top: "-40px",
			},
		},
		header: {
			fontSize: "18px",
			marginBottom: "6px",
			textAlign: "center",
		},
		text: {
			textAlign: "center",
		},
	},
});

const BenefitCarousel = ({ header, icon, text, classes }) => {
	return (
		<div className={classes.root}>
			<div className={classes.header}>{header}</div>
			<div className={classes.text}>{text}</div>
			{icon}
		</div>
	);
};

BenefitCarousel.propTypes = {
	header: PropTypes.string.isRequired,
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.element]).isRequired,
	icon: PropTypes.node,
};
BenefitCarousel.defaultProps = {
	header: "",
	text: "",
	icon: null,
};
export default withStyles(styles)(BenefitCarousel);
